import PropTypes from 'prop-types'
import React, { Children, useState } from 'react'

/** Default react-bootstrap accordion component -  https://react-bootstrap.github.io/components.html#panels-accordion.

@example ../../../../docs/external/container/AAccordion.md */

const AAccordion = ({ children, defaultActiveKey }) => {
  const [currentOpenKey, setCurrentOpenKey] = useState(defaultActiveKey)

  const handleKeyChange = (key) => {
    if (key === currentOpenKey) {
      return setCurrentOpenKey(undefined)
    }

    setCurrentOpenKey(key)
  }

  const childrenWithProps = Children.map(children, (child) => {
    const childEventKey = child?.props?.eventKey

    if (!child || !childEventKey) return child

    return React.cloneElement(child, {
      collapsible: true,
      expanded: childEventKey === currentOpenKey,
      onSelect: () => handleKeyChange(childEventKey),
    })
  })

  return <div className="accordion">{childrenWithProps}</div>
}

AAccordion.propTypes = {
  /** content of the accordion */
  children: PropTypes.node,
  /** which section of the accordion should be open by default */
  defaultActiveKey: PropTypes.any,
}

export default AAccordion
